/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/v_cosine.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Calculates the cosine similarity between two dense_vectors.
 *
 * @example
 * from colors
 * | where color != "black"
 * | eval similarity = v_cosine(rgb_vector, [0, 255, 255])
 * | sort similarity desc, color asc
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'v_cosine',
  signatures: [
    {
      params: [
        {
          name: 'left',
          type: 'dense_vector',
          optional: false,
        },
        {
          name: 'right',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
